import React from 'react';
import { Mesh as ThreeMesh } from 'three/src/objects/Mesh';
import useStopeModel, { StopeSourceBounds } from 'modules/project/StopeFillPage/Three/useStopeModel';
import { buildMediaUrl } from './geometryLoader';

interface UseStopeGeometryResult {
  mesh: ThreeMesh | null;
  sourceBounds: StopeSourceBounds | null;
  isLoading: boolean;
  path: string | null;
}

const useStopeGeometry = (stopeGeometryPath: string | undefined): UseStopeGeometryResult => {
  const [mesh, setMesh] = React.useState<ThreeMesh | null>(null);
  const [sourceBounds, setSourceBounds] = React.useState<StopeSourceBounds | null>(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [path, setPath] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!stopeGeometryPath) {
      setMesh(null);
      setSourceBounds(null);
      setIsLoading(false);
      setPath(null);
      return undefined;
    }

    let cancelled = false;
    setIsLoading(true);

    useStopeModel(buildMediaUrl(stopeGeometryPath))
      .then((result) => {
        if (cancelled) return;
        setMesh(result?.stopeModel ?? null);
        setSourceBounds(result?.sourceBounds ?? null);
        setIsLoading(false);
        setPath(stopeGeometryPath);
      })
      .catch(() => {
        if (cancelled) return;
        setMesh(null);
        setSourceBounds(null);
        setIsLoading(false);
        setPath(stopeGeometryPath);
      });

    return () => { cancelled = true; };
  }, [stopeGeometryPath]);

  return {
    mesh, sourceBounds, isLoading, path,
  };
};

export default useStopeGeometry;
